// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8490b4a5","179":"7671c680","215":"f82ac6ac","478":"d13a60b8","691":"b23c6588","842":"3ae63786"}[chunkId] + ".chunk.js";
};